function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import OlView from 'ol/View';
import { useEffect, useMemo } from 'react';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
import usePrevious from '../hooks/usePrevious';
import { useOpenLayers } from '../openlayers-context';
import { getEvents, getOptions } from '../utils';
var allViewEvents = {
  'change:center': undefined,
  'change:zoom': undefined
};
var allViewOptions = {
  center: undefined,
  extent: undefined,
  maxResolution: undefined,
  minResolution: undefined,
  maxZoom: undefined,
  minZoom: undefined,
  projection: undefined,
  resolution: undefined,
  resolutions: undefined,
  rotation: undefined,
  zoom: undefined,
  zoomFactor: undefined
};
export var View = _ref => {
  var props = _extends({}, _ref);

  var {
    map
  } = useOpenLayers();
  var prevCenter = usePrevious(props.center);
  var prevZoom = usePrevious(props.zoom);
  var memoizedProps = useDeepCompareMemoize(props);
  var memoizedOptions = useMemo(() => getOptions(Object.assign(allViewOptions, memoizedProps)), [memoizedProps]);
  var memoizedEvents = useMemo(() => getEvents(allViewEvents, memoizedOptions), [memoizedOptions]);
  useEffect(() => {
    if (!map) return;
    var isExtentInvalidOrEmpty = !!props.extent && (props.extent.length !== 4 || props.extent[2] <= props.extent[0] || props.extent[3] <= props.extent[1]);
    if (isExtentInvalidOrEmpty) console.error("Bounding box extent '".concat(props.extent, "' is invalid or empty."));

    var viewOptions = _objectSpread(_objectSpread({}, memoizedOptions), {}, {
      extent: !isExtentInvalidOrEmpty ? props.extent : undefined
    });

    var view = new OlView(viewOptions);

    for (var eventName in memoizedEvents) {
      // TODO: This should not be any. Fix this.
      view.on(eventName, memoizedEvents[eventName]);
    }

    map.setView(view);
    return () => {
      map.getView().dispose();

      for (var _eventName in memoizedEvents) {
        // TODO: This should not be any. Fix this.
        view.un(_eventName, memoizedEvents[_eventName]);
      }
    };
  }, [map, memoizedEvents, memoizedOptions, props.extent]);
  useEffect(() => {
    try {
      var centerCoordinate = props.center;
      var isNewCenter = centerCoordinate && (!prevCenter || !centerCoordinate.every((c, i) => c === prevCenter[i]));

      if (isNewCenter) {
        map === null || map === void 0 ? void 0 : map.getView().setCenter(centerCoordinate.map(Number));
      }
    } catch (_unused) {
      console.warn('Coordinate is not a valid coordinate, e.g. [0, 0]');
    }

    if (props.zoom && props.zoom !== prevZoom) {
      map === null || map === void 0 ? void 0 : map.getView().setZoom(props.zoom);
    }
  }, [map, prevCenter, prevZoom, props.center, props.zoom]);
  return null;
};